import React, { Component } from "react";
import { List, Card, Avatar, Spin } from "antd";
import DatetimeFormat from "../DateTimeFormat";
import InfiniteScroll from "react-infinite-scroller";
import DefaultUserImage from "../../assets/img/avatar_user_black.png";

import { debounce } from "../../utils/debounce";
import { mobileDetect } from "../../utils/mobileDetect";

import sanitizeHtml from "sanitize-html";

import "./MessageList.scss";

let moment = require("moment");

const { Meta } = Card;

class MessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "message-list-" + this.props.id,
      messageContainerRef: null,
      prevScrollTop: 0,
    };
    this.lastTimestamp = 0;
    this.dismissNewMessageSpam = this.dismissNewMessageSpam.bind(this);
    this.setContainerRef = this.setContainerRef.bind(this);
  }

  componentDidMount() {
    if (mobileDetect()) {
      window.addEventListener("resize", this.handleMessageScroll);
    }
  }

  componentWillUnmount() {
    if (mobileDetect()) {
      window.removeEventListener("resize", this.handleMessageScroll);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loadingMore || this.props.loadingMore) return;

    if (
      prevState.messageContainerRef &&
      prevProps.list.length !== this.props.list.length &&
      (prevState.messageContainerRef.scrollTop === this.state.prevScrollTop ||
        prevProps.list.length === 0)
    ) {
      prevState.messageContainerRef.scrollTop =
        prevState.messageContainerRef.scrollHeight;
      this.setState({
        prevScrollTop: prevState.messageContainerRef.scrollTop,
      });
    } else if (
      prevState.messageContainerRef &&
      prevProps.list.length !== this.props.list.length &&
      prevState.messageContainerRef.scrollTop !== this.state.prevScrollTop &&
      !this.props.isLastMessageFromCurrentUser
    ) {
      this.props.setNewMessagesToScrollCount(true);
    }
  }

  handleMessageScroll = debounce(() => {
    if (this.state.messageContainerRef) {
      this.state.messageContainerRef.scrollTo(
        0,
        this.state.messageContainerRef.scrollHeight
      );
    }
  }, 300);

  canPostDifferentDaySpan(timestamp, index) {
    if (
      index === 0 ||
      moment(new Date(this.formatDate(this.lastTimestamp)))
        .startOf("day")
        .diff(
          moment(new Date(this.formatDate(timestamp))).startOf("day"),
          "days"
        ) !== 0
    ) {
      this.lastTimestamp = timestamp;
      return true;
    }
    return false;
  }

  formatDate(dateToFormat) {
    let formattedDate = dateToFormat;
    if (isNaN(formattedDate)) {
      let date = formattedDate.split(" ")[0];
      let time = formattedDate.split(" ")[1];
      date = date.split("-");
      time = time.split(":");
      formattedDate =
        date[1] +
        "/" +
        date[2] +
        "/" +
        date[0] +
        "/" +
        time[0] +
        ":" +
        time[1] +
        ":" +
        time[2];
    }
    return formattedDate;
  }

  canPostMessageAvatar(item, index) {
    let previousMessage = this.props.list[index - 1];
    if (
      previousMessage &&
      previousMessage.from &&
      previousMessage.from.username === item.from.username
    ) {
      if (
        moment(new Date(this.formatDate(item.sendDate))).diff(
          moment(new Date(this.formatDate(previousMessage.sendDate))),
          "minutes"
        ) < 1
      ) {
        return false;
      }
    }
    return true;
  }

  getTitle(item) {
    return (
      <div className="message-list-header">
        <span className="message-list-title">
          {item.from && item.from.username}
        </span>
        <span className="bullet">&#8226;</span>
        <DatetimeFormat className="time" time dateTime={item.sendDate} />
      </div>
    );
  }

  dismissNewMessageSpam(event) {
    let elem = event.target;
    if (elem.scrollHeight - elem.scrollTop === elem.clientHeight) {
      this.props.setNewMessagesToScrollCount(false, 0);
    }
  }

  setContainerRef(node) {
    node && node.addEventListener("scroll", this.dismissNewMessageSpam);
    !node &&
      this.state.messageContainerRef.removeEventListener(
        "scroll",
        this.dismissNewMessageSpam
      );
    this.setState({
      messageContainerRef: node,
    });
    this.props.setMessageListRef && this.props.setMessageListRef(node);
  }

  getAvatar(item) {
    return <Avatar src={DefaultUserImage} />;
  }

  getItemDescription(text) {
    text = sanitizeHtml(text, { allowedTags: [] });
    text = text.replace(/\B(@[a-zA-Z\u00C0-\u017F0-9._-]+)/g, (match) => {
      return `<span style="color: #1976D2">${match}</span>`;
    });
    return <span dangerouslySetInnerHTML={{ __html: text }} />;
  }

  render() {
    return (
      <div className="message-list-container" ref={this.setContainerRef}>
        <InfiniteScroll
          loadMore={this.props.handleInfiniteOnLoad}
          hasMore={this.props.hasMorePages}
          initialLoad={false}
          isReverse={true}
          useWindow={false}
        >
          <List
            id={this.state.id}
            className="message-list"
            locale={{ emptyText: "" }}
            dataSource={this.props.list}
            loading={this.props.loading}
            header={this.props.hasMorePages && <Spin />}
            renderItem={(item, index) => {
              if (this.canPostMessageAvatar(item, index)) {
                return (
                  <List.Item>
                    {this.canPostDifferentDaySpan(item.sendDate, index) ? (
                      <DatetimeFormat
                        className="date-time"
                        long
                        dateTime={item.sendDate}
                      />
                    ) : (
                      false
                    )}
                    <Card bordered={false} className="single-message">
                      <Meta
                        avatar={this.getAvatar(item)}
                        title={this.getTitle(item)}
                        description={this.getItemDescription(item.content)}
                      />
                    </Card>
                  </List.Item>
                );
              }
              return (
                <List.Item className="hidden-avatar">
                  {this.canPostDifferentDaySpan(item.sendDate, index) ? (
                    <DatetimeFormat
                      className="date-time"
                      long
                      dateTime={item.sendDate}
                    />
                  ) : (
                    false
                  )}
                  <Card bordered={false} className="single-message">
                    <Meta description={this.getItemDescription(item.content)} />
                  </Card>
                </List.Item>
              );
            }}
          />
        </InfiniteScroll>
      </div>
    );
  }
}

export default MessageList;
